export default __webpack_public_path__ + "static/media/workorder.f1c01a5a.svg";